import Routes from "@/router/routes";

export const home = {
  id: Routes.HOME_ROUTE,
  name: 'Home',
  icon: 'ns-icon-ico006',
  iconSelected: 'ns-icon-ico001',
  paths: 2,
  to: {name: Routes.HOME_ROUTE},
};

export const homeDesktop = {
  id: Routes.HOME_ROUTE,
  name: 'Home',
  icon: 'ns-icon-ico073',
  iconSelected: 'ns-icon-ico074',
  paths: 2,
  to: {name: Routes.HOME_ROUTE},
};

export const doctors = {
  id: Routes.DOCTORS_ROUTE,
  name: 'Doctors',
  icon: 'ns-icon-ico007',
  iconSelected: 'ns-icon-ico002',
  to: {name: Routes.DOCTORS_ROUTE},
};

export const services = {
  id: Routes.SERVICES_ROUTE,
  name: 'Services',
  icon: 'ns-icon-ico008',
  iconSelected: 'ns-icon-ico003',
  to: {name: Routes.SERVICES_ROUTE},
};

export const files = {
  id: Routes.FILES_ROUTE,
  name: 'Files',
  icon: 'ns-icon-ico009',
  iconSelected: 'ns-icon-ico004',
  to: {name: Routes.FILES_ROUTE},
};

export const messages = {
  id: Routes.MESSAGES_ROUTE,
  name: 'Messages',
  icon: 'ns-icon-ico010',
  iconSelected: 'ns-icon-ico005',
  to: {name: Routes.MESSAGES_ROUTE},
};

export const navMobile = [
  home,
  doctors,
  services,
  files,
  messages
];

export const navDesktop = [
  homeDesktop,
  doctors,
  services,
  files,
  messages
];